import { useState } from "react";
import { useAppSelector } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import { Banner } from "../../../ui/organisms/banner";
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { CustomerOtherOdcList } from "../measuresOtherOdc/customerList";
import { CodexCustomerList } from "./codexList";

export function CustomerMeasueres() {
    const sessionState = useAppSelector(state => state.session)

    const [selectedTab, setSelectedTab] = useState<number>(0)

    if (sessionState.selected.customerId)
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
                breadcrumbItems={['Gestione Provvedimenti', 'Provvedimenti']}
                noPaddingLat
                headerLabel="Provvedimenti"
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
            >
                <div>
                    <CustomHorizontalTab
                        selectedIndex={selectedTab}
                        onTabClick={(index) => setSelectedTab(index)}
                    >
                        <div>Elenco Provvedimenti</div>
                        <div>Elenco Provvedimenti altro OdC</div>
                    </CustomHorizontalTab>
                    <div className="fieldset bg-brandPrimary-200">
                        {
                            selectedTab === 0 &&
                            <CodexCustomerList />
                        }
                        {
                            selectedTab === 1 &&
                            <CustomerOtherOdcList />
                        }
                    </div>
                </div>
            </Layout>
        )

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Provvedimenti']}
            noPaddingLat
            headerLabel={"Provvedimenti Cliente"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'elenco"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'elenco")
                }}
            />
        </Layout>
    )
}